import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class s3ManagementService {

  constructor(private httpClient: HttpClient) {}

  s3Upload(brandName: string, fileToUpload: any[], vinNumber: string): Observable<any> {
    const formData = new FormData();

    fileToUpload.forEach(file => {
      formData.append('File', this.resolveUploadBlob(file), file.name);
    });

    return this.httpClient.post(
      `${environment.apiUrl}/v1/api/s3Upload/upload?vinNumber=${vinNumber}&brandName=${brandName}`,
      formData
    );
  }

  private resolveUploadBlob(file: any): Blob {
    if (file?.file instanceof Blob) {
      return file.file;
    }

    if (file instanceof Blob) {
      return file;
    }

    throw new Error('Unsupported upload payload');
  }
}
